import { z } from 'zod';

import {
  BackgroundColor,
  ImageSize,
  CmsImage,
  PaddingStyle,
  VisibilitySettingStyle,
  WidthStyle,
  OrderStyle,
  JustifyContent,
} from '../models';
import { BasePType } from './base';
import { Image } from './image';
import { PTypes } from './index';

const baseFlexboxItem = BasePType.extend({
  type: z.enum(['flexboxItem']),
  bgColor: z.nullable(BackgroundColor),
  bottomBorder: z.boolean(),
  class: z.string().nullable(),
  childStructureClasses: z.string().optional(),
  fbiDesktop: z.nullable(WidthStyle),
  fbiMobile: z.nullable(WidthStyle),
  fbiTablet: z.nullable(WidthStyle),
  flexboxItemDesktopOrder: z.nullable(OrderStyle),
  flexboxItemMobileOrder: z.nullable(OrderStyle),
  flexboxItemTabletOrder: z.nullable(OrderStyle),
  justifyContent: z.nullable(JustifyContent).optional(),
  image: z.array(Image).optional(),
  imageSize: z.nullable(ImageSize),
  leftBorder: z.boolean(),
  overlayColor: z.string().nullable().optional(),
  mobileCenter100: z.boolean(),
  paddingBottom: z.nullable(PaddingStyle),
  paddingLeft: z.nullable(PaddingStyle),
  paddingRight: z.nullable(PaddingStyle),
  paddingTop: z.nullable(PaddingStyle),
  rightBorder: z.boolean(),
  roundedCorner: z
    .union([z.string().array(), z.string()])
    .optional()
    .nullable(),
  topBorder: z.boolean(),
  visibility: z.nullable(VisibilitySettingStyle),
  webpMedia: z.array(CmsImage).optional().nullable(),
});

export type FlexboxItem = z.infer<typeof baseFlexboxItem> & {
  nestedFlexboxContent?: PTypes[];
};

export const FlexboxItem: z.ZodType<FlexboxItem> = baseFlexboxItem.extend({
  nestedFlexboxContent: z.lazy(() => z.array(PTypes)).optional(),
});
